window.onerror = function (message, source, lineno, colno, error) {
  // Suppress all errors
  return true; // Prevents the default browser behavior (showing errors in the console)
};

// check which additional product (in this case brustband) is selected
// setInterval(() => {

const optionSelectorAdditionalProduct = document.querySelectorAll(
  ".fi-custom-option-selector-additional-product .wrapper-dropdown"
);

optionSelectorAdditionalProduct.forEach(
  (optionSelectorAdditionalProductSelected) => {
    optionSelectorAdditionalProductSelected.addEventListener("click", () => {
      var additional_selected_product_id = document.querySelector(
        ".fi-custom-option-selector-additional-product .destination"
      ).dataset.productId;

      // make selected product selector group active
      document
        .querySelectorAll(
          ".fi-custom-option-selector-additional-product-options"
        )
        .forEach(function (AdditionalProductOptions) {
          AdditionalProductOptions.classList.remove(
            "fi-custom-option-selector-additional-product-selected"
          );
          if (
            AdditionalProductOptions.dataset.productId ==
            additional_selected_product_id
          ) {
            AdditionalProductOptions.classList.add(
              "fi-custom-option-selector-additional-product-selected"
            );
          }
        });

      // make selected product data active
      document
        .querySelectorAll(".additional-product-data")
        .forEach(function (additionalProductDataItem) {
          additionalProductDataItem.classList.remove(
            "additional-product-data-selected"
          );
          if (
            additionalProductDataItem.dataset.additionalProductDataId ==
            additional_selected_product_id
          ) {
            additionalProductDataItem.classList.add(
              "additional-product-data-selected"
            );
          }
        });
    });
  }
);

// }, 500);

//

// selectedAdditionalAll.forEach((selectedAdditionalAllselected) => {
//     const selectedAdditionaloptionsContainer = selectedAdditionalAllselected.children[2];
//     const selectedAdditionaloptionsList = selectedAdditionalAllselected.querySelectorAll("div.wrapper-dropdown li");
// const selectedAdditionalAll = document.querySelector(".fi-custom-option-selector-additional-product-selected .wrapper-dropdown");

// selectedAdditionalAll.addEventListener("click", () => {
setInterval(() => {
  var additional_product_option1 = document.querySelector(
    ".fi-custom-option-selector-additional-product-selected .option-set-1 .destination"
  ).dataset.optionValue;
  var additional_product_option2 = document.querySelector(
    ".fi-custom-option-selector-additional-product-selected .option-set-2 .destination"
  ).dataset.optionValue;
  var additional_product_selected_variant_id = null;

  document
    .querySelectorAll(
      ".additional-product-data-selected .additional-product-options-data"
    )
    .forEach(function (additionalProductOptionsDataItem) {
      additionalProductOptionsDataItem.classList.remove(
        "additional-product-variant-selected"
      );

      if (
        additionalProductOptionsDataItem.dataset.optionFirst ==
          additional_product_option1 &&
        additionalProductOptionsDataItem.dataset.optionSecond ==
          additional_product_option2
      ) {
        additional_product_selected_variant_id =
          additionalProductOptionsDataItem.dataset.variantId;
      }
    });

  document
    .querySelector(
      `.additional-product-options-data[data-variant-id="${additional_product_selected_variant_id}"]`
    )
    .classList.add("additional-product-variant-selected");
}, 500);
// });

// });

const selectedMainAll = document.querySelectorAll(
  ".fi-custom-option-selector-main-product .wrapper-dropdown"
);

selectedMainAll.forEach((selectedMainAllselected) => {
  const selectedMainoptionsContainer = selectedMainAllselected.children[2];
  const selectedMainoptionsList = selectedMainAllselected.querySelectorAll(
    "div.wrapper-dropdown li"
  );

  selectedMainAllselected.addEventListener("click", () => {
    var main_product_option1 = document.querySelector(
      ".fi-custom-option-selector-main-product .option-set-1 .destination"
    ).dataset.optionValue;
    var main_product_option2 = document.querySelector(
      ".fi-custom-option-selector-main-product .option-set-2 .destination"
    ).dataset.optionValue;
    var main_product_selected_variant_id = null;

    document
      .querySelectorAll(".main-product-options-data")
      .forEach(function (mainProductOptionsDataItem) {
        mainProductOptionsDataItem.classList.remove(
          "main-product-variant-selected"
        );
        if (
          mainProductOptionsDataItem.dataset.optionFirst ==
            main_product_option1 &&
          mainProductOptionsDataItem.dataset.optionSecond ==
            main_product_option2
        ) {
          main_product_selected_variant_id =
            mainProductOptionsDataItem.dataset.variantId;
        }
      });

    document
      .querySelector(
        `.main-product-options-data[data-variant-id="${main_product_selected_variant_id}"]`
      )
      .classList.add("main-product-variant-selected");
  });
});

const selectedAll = document.querySelectorAll(".wrapper-dropdown");

selectedAll.forEach((selected) => {
  const optionsContainer = selected.children[2];
  const optionsList = selected.querySelectorAll("div.wrapper-dropdown li");

  selected.addEventListener("click", () => {
    let arrow = selected.children[1];

    if (selected.classList.contains("active")) {
      handleDropdown(selected, arrow, false);
    } else {
      let currentActive = document.querySelector(".wrapper-dropdown.active");

      if (currentActive) {
        let anotherArrow = currentActive.children[1];
        handleDropdown(currentActive, anotherArrow, false);
      }

      handleDropdown(selected, arrow, true);
    }
  });

  // update the display of the dropdown
  for (let o of optionsList) {
    o.addEventListener("click", () => {
      selected.querySelector(".selected-display").innerHTML = o.innerHTML;
      selected.querySelector(".selected-display").dataset.optionValue =
        o.dataset.optionValue;
      selected.querySelector(".selected-display").dataset.productId =
        o.dataset.productId;

      document
        .querySelectorAll(".wrapper-dropdown .destination")
        .forEach((element) => {
          // Check if the data-option-value is not 'empty'
          setInterval(() => {
            if (element.dataset.optionValue != "empty") {
              // Check the locale
              const locale = document.querySelector("#locale-iso-code")
                ? document.querySelector("#locale-iso-code").value
                : "default";

              // Modify the data-text based on the locale
              element.dataset.textContent = element.dataset.textContent
                .replace("wählen", "")
                .trim();
            }
          }, 10);
        });
    });
  }
});

// check if anything else other than the dropdown is clicked
window.addEventListener("click", function (e) {
  if (e.target.closest(".wrapper-dropdown") === null) {
    closeAllDropdowns();
  }
});
setInterval(() => {
  // close all the dropdowns
  function closeAllDropdowns() {
    const selectedAll = document.querySelectorAll(".wrapper-dropdown");
    selectedAll.forEach((selected) => {
      const optionsContainer = selected.children[2];
      let arrow = selected.children[1];

      handleDropdown(selected, arrow, false);
    });
  }
}, 500);

// open all the dropdowns
function handleDropdown(dropdown, arrow, open) {
  if (open) {
    arrow.classList.add("rotated");
    dropdown.classList.add("active");
  } else {
    arrow.classList.remove("rotated");
    dropdown.classList.remove("active");
  }
}

//
// price change
setInterval(() => {
  if (
    document.querySelector(
      ".fi-custom-option-selector-additional-product .destination"
    ).dataset.productId == "empty" ||
    document.querySelector(
      ".fi-custom-option-selector-additional-product .destination"
    ).dataset.productId == "null"
  ) {
    if (
      document.querySelector(
        ".fi-custom-option-selector-main-product .destination"
      ).dataset.optionValue != "empty"
    ) {
      document.querySelector(".fi-bundle-product-custom-price").style.display =
        "none";
      document.querySelector(".product-info__price").style.display = "block";
      var mainProductVariantDiv = document.querySelector(
        ".main-product-options-data.main-product-variant-selected"
      );
      document.querySelector(".product-info__price sale-price").innerHTML =
        mainProductVariantDiv.dataset.variantPriceWithSymbol;
      document.querySelector(
        ".product-info__price compare-at-price"
      ).innerHTML = mainProductVariantDiv.dataset.comparePriceWithSymbol;

      var mainProductDiscountPercentage =
        100 -
        (
          (parseFloat(mainProductVariantDiv.dataset.variantPrice) /
            parseFloat(mainProductVariantDiv.dataset.comparePrice)) *
          100
        ).toFixed(0);
      document.querySelector(
        ".product-info__price .product-info__badge-list .badge--on-sale"
      ).innerHTML =
        '<span class="saving-lang-text"></span>' +
        mainProductDiscountPercentage +
        "%";
    }
  } else {
    document.querySelector(".fi-bundle-product-custom-price").style.display =
      "none";
    document.querySelector(".product-info__price").style.display = "block";

    var takePriceAdditional = 0;
    var takePriceCompareAdditional = 0;
    //

    var mainProductVariantDiv = document.querySelector(
      ".main-product-options-data.main-product-variant-selected"
    );
    var additionalProductVariantDiv = document.querySelector(
      ".additional-product-data-selected .additional-product-variant-selected"
    );
    //

    takePriceAdditional =
      parseFloat(additionalProductVariantDiv.dataset.variantPrice) / 100;
    var takePriceMain =
      parseFloat(mainProductVariantDiv.dataset.variantPrice) / 100;
    var makeBundleFinalPrice = (takePriceAdditional + takePriceMain).toFixed(2);
    var makeBundleFinalString = makeBundleFinalPrice.toString();
    var makeBundleFinalPriceWithSymbol = "€ " + makeBundleFinalString + " EUR";
    document.querySelector(".product-info__price sale-price").innerHTML =
      makeBundleFinalPriceWithSymbol.replace(".", ",");

    //

    takePriceCompareAdditional =
      parseFloat(additionalProductVariantDiv.dataset.comparePrice) / 100;
    var takePriceMainCompare =
      parseFloat(mainProductVariantDiv.dataset.comparePrice) / 100;
    var makeBundleFinalPriceCompare = (
      takePriceCompareAdditional + takePriceMainCompare
    ).toFixed(2);
    var makeBundleFinalStringCompare = makeBundleFinalPriceCompare.toString();
    var makeBundleFinalPriceWithSymbolCompare =
      "€ " + makeBundleFinalStringCompare + " EUR";
    document.querySelector(".product-info__price compare-at-price").innerHTML =
      makeBundleFinalPriceWithSymbolCompare.replace(".", ",");

    // savings changes on price change
    if (additionalProductVariantDiv) {
      // var always_saving =
      //   document.querySelector('.product-info__price compare-at-price').style.display='none';
      //   document.querySelector('.product-info__badge-list').style.display='none';
    }

    document.querySelector(".product-info__price compare-at-price").innerHTML =
      document.querySelector(".always-compare-price-with-symbol").value;
    console.log(
      "always compare pric with symbol:",
      document.querySelector(".always-compare-price-with-symbol").value
    );

    var savings =
      (makeBundleFinalPrice /
        parseFloat(document.querySelector(".always-compare-price").value)) *
      100;
    document.querySelector(
      ".product-info__price_bundle on-sale-badge"
    ).innerHTML =
      "<span class='saving-lang-text'></span> " +
      (100 - savings.toFixed(0)) +
      "%";
  }
}, 500);

// var additionalProductDiv = document.querySelectorAll(
//   ".additional-product-data"
// );
// additionalProductDiv.forEach((el) => {
//   if (el.classList.contains("additional-product-data-selected")) {
//     var mainProductVariantDiv = document.querySelector(
//       ".main-product-options-data.main-product-variant-selected"
//     );
//     var additionalProductVariantDiv = document.querySelector(
//       ".additional-product-data-selected .additional-product-variant-selected"
//     );
//     var takePriceAdditional =
//       parseFloat(additionalProductVariantDiv.dataset.variantPrice) / 100;
//     var takePriceMain =
//       parseFloat(mainProductVariantDiv.dataset.variantPrice) / 100;
//     var makeBundleFinalPrice = (takePriceAdditional + takePriceMain).toFixed(
//       2
//     );
//     var makeBundleFinalString = makeBundleFinalPrice.toString();
//     var makeBundleFinalPriceWithSymbol =
//       "€ " + makeBundleFinalString + " EUR";
//     document.querySelector(".product-info__price sale-price").innerHTML =
//       makeBundleFinalPriceWithSymbol;
//   }
//   else {
//     var mainProductVariantDiv = document.querySelector(
//       ".main-product-options-data.main-product-variant-selected"
//     );
//     document.querySelector(".product-info__price sale-price").innerHTML =
//       mainProductVariantDiv.dataset.variantPriceWithSymbol;
//   }
// });
setInterval(() => {
  // empty checks

  document
    .querySelectorAll(".fi-custom-option-selector-main-product .destination")
    .forEach((e) => {
      // check main product fields empty or not
      if (e.dataset.optionValue == "empty") {
        document
          .querySelector("#custom-buy-button")
          .setAttribute("disabled", "true");
      } else {
        // if not empty check main product availability | if not -> disable add to cart button
        if (
          document.querySelector(".main-product-variant-selected").dataset
            .variantAvailability == "Not Available"
        ) {
          document
            .querySelector(".fi-custom-option-selector-main-product")
            .classList.add("variant-not-available");
        }
        // if main product is available ->  enable add to cart button
        else {
          document
            .querySelector(".fi-custom-option-selector-main-product")
            .classList.remove("variant-not-available");
          // now check additional product selected is empty or not
          if (
            document.querySelector("#dropdownAddProduct .destination").dataset
              .productId == "null"
          ) {
            document
              .querySelector("#custom-buy-button")
              .removeAttribute("disabled");
          }
          // if additional product selected is not empty
          else {
            // check additional product fields empty or not

            document
              .querySelectorAll(
                ".fi-custom-option-selector-additional-product-selected .destination"
              )
              .forEach((e) => {
                if (e.dataset.optionValue == "empty") {
                  document
                    .querySelector("#custom-buy-button")
                    .setAttribute("disabled", "true");
                } else {
                  if (
                    document.querySelector(
                      ".additional-product-data-selected .additional-product-variant-selected"
                    ).dataset.variantAvailability == "Not Available"
                  ) {
                    document
                      .querySelector("#custom-buy-button")
                      .setAttribute("disabled", "true");

                    document
                      .querySelector(
                        ".fi-custom-option-selector-additional-product-selected"
                      )
                      .classList.add("variant-not-available");
                  } else {
                    document
                      .querySelector("#custom-buy-button")
                      .removeAttribute("disabled");
                    document
                      .querySelector(
                        ".fi-custom-option-selector-additional-product-selected"
                      )
                      .classList.remove("variant-not-available");
                  }
                }
              });
          }
        }
      }
    });

  if (
    document.querySelector(
      ".additional-product-data-selected .additional-product-variant-selected"
    ).dataset.variantAvailability == "Not Available"
  ) {
    document
      .querySelector("#custom-buy-button")
      .setAttribute("disabled", "true");

    document
      .querySelector(".fi-custom-option-selector-additional-product-selected")
      .classList.add("variant-not-available");
  }

  if (
    document.querySelector(".main-product-variant-selected").dataset
      .variantAvailability == "Not Available"
  ) {
    document
      .querySelector("#custom-buy-button")
      .setAttribute("disabled", "true");

    document
      .querySelector(".fi-custom-option-selector-main-product")
      .classList.add("variant-not-available");
  }
}, 460);

// for main product color to be selected auto if color is only 1

setInterval(() => {
  var main_product_option1 = document.querySelector(
    ".fi-custom-option-selector-main-product .option-set-1 .destination"
  ).dataset.optionValue;
  var main_product_option2 = document.querySelector(
    ".fi-custom-option-selector-main-product .option-set-2 .destination"
  ).dataset.optionValue;
  var main_product_selected_variant_id = null;

  document
    .querySelectorAll(".main-product-options-data")
    .forEach(function (mainProductOptionsDataItem) {
      mainProductOptionsDataItem.classList.remove(
        "main-product-variant-selected"
      );
      if (
        mainProductOptionsDataItem.dataset.optionFirst ==
          main_product_option1 &&
        mainProductOptionsDataItem.dataset.optionSecond == main_product_option2
      ) {
        main_product_selected_variant_id =
          mainProductOptionsDataItem.dataset.variantId;
      }
    });

  document
    .querySelector(
      `.main-product-options-data[data-variant-id="${main_product_selected_variant_id}"]`
    )
    .classList.add("main-product-variant-selected");
}, 440);

// Options Availability
// if main product has a single color pre selected
setInterval(() => {
  if (
    document
      .querySelector(".fi-custom-option-selector-main-product .option-set-2")
      .classList.contains("hidden")
  ) {
    var mainProductOption2 = null;
    var mainProductOption2Availability = [];

    if (
      document.querySelector(
        ".fi-custom-option-selector-main-product .option-set-2 .destination"
      ).dataset.optionValue
    ) {
      mainProductOption2 = document.querySelector(
        ".fi-custom-option-selector-main-product .option-set-2 .destination"
      ).dataset.optionValue;
    }

    document
      .querySelectorAll(".main-product-data .main-product-options-data")
      .forEach((e) => {
        if (e.dataset.optionSecond == mainProductOption2) {
          mainProductOption2Availability.push(e.dataset.variantAvailability);
        }
      });

    const mainProductOptionsitems = document.querySelectorAll(
      ".fi-custom-option-selector-main-product .dropdown .item"
    );

    mainProductOptionsitems.forEach((item, index) => {
      if (index < mainProductOption2Availability.length) {
        item.classList.add(
          `variant-${mainProductOption2Availability[index].replace(" ", "")}`
        );
      }
    });
  }
}, 100);
// Options Availability
// if main product has more than one color and not pre selected

setInterval(() => {
  document
    .querySelectorAll(
      ".fi-custom-option-selector-main-product .option-set-1 .item"
    )
    .forEach((opt1Item) => {
      opt1Item.onclick = function () {
        if (
          !document
            .querySelector(
              ".fi-custom-option-selector-main-product .option-set-2"
            )
            .classList.contains("hidden")
        ) {
          var mainProductOption1 = null;
          var mainProductOption22Availability = [];
          mainProductOption1 = document.querySelector(
            ".fi-custom-option-selector-main-product .option-set-1 .destination"
          ).dataset.optionValue;

          document
            .querySelectorAll(".main-product-data .main-product-options-data")
            .forEach((e) => {
              if (e.dataset.optionFirst == mainProductOption1) {
                mainProductOption22Availability.push(
                  e.dataset.variantAvailability
                );
              }
            });

          const mainProductOptionsitems = document.querySelectorAll(
            ".fi-custom-option-selector-main-product .option-set-2  .item"
          );

          mainProductOptionsitems.forEach((item, index) => {
            item.classList.remove("variant-Available");
            item.classList.remove("variant-NotAvailable");
            if (index < mainProductOption22Availability.length) {
              item.classList.add(
                `variant-${mainProductOption22Availability[index].replace(
                  " ",
                  ""
                )}`
              );
            }
          });
        }
      };
    });
}, 10);
// Options Availability
// For Additional product

//

setInterval(() => {
  document
    .querySelectorAll(
      ".fi-custom-option-selector-additional-product-selected .option-set-1 .item"
    )
    .forEach((opt1Item) => {
      opt1Item.onclick = function () {
        var AdditionalProductOption1 = null;
        var AdditionalProductOption2Availability = [];
        AdditionalProductOption1 = document.querySelector(
          ".fi-custom-option-selector-additional-product-selected .option-set-1 .destination"
        ).dataset.optionValue;

        document
          .querySelectorAll(
            ".additional-product-data-selected .additional-product-options-data"
          )
          .forEach((e_Add) => {
            if (e_Add.dataset.optionFirst == AdditionalProductOption1) {
              AdditionalProductOption2Availability.push(
                e_Add.dataset.variantAvailability
              );
            }
          });

        const mainProductOptionsitems = document.querySelectorAll(
          ".fi-custom-option-selector-additional-product-selected .option-set-2  .item"
        );

        mainProductOptionsitems.forEach((item, index) => {
          item.classList.remove("variant-Available");
          item.classList.remove("variant-NotAvailable");
          if (index < AdditionalProductOption2Availability.length) {
            item.classList.add(
              `variant-${AdditionalProductOption2Availability[index].replace(
                " ",
                ""
              )}`
            );
          }
        });
      };
    });
}, 1);

// main product stock show
// setInterval(() => {
//   var inventoryQuantity = document.querySelector(
//     ".main-product-variant-selected"
//   ).dataset.inventoryQuantity;
//   if (inventoryQuantity && inventoryQuantity != "null") {
//     var qtyWidth = inventoryQuantity * 3;
//     document.querySelector(
//       ".main-product-stock-inventory .qty-info"
//     ).innerHTML = `${inventoryQuantity} auf Lager`;
//     document.querySelector(
//       ".main-product-stock-inventory .qty-width"
//     ).dataset.qtyWidth = qtyWidth + "%";
//     document.documentElement.style.setProperty("--qtyWidth", qtyWidth + "%");
//     document.documentElement.style.setProperty("--qtyWidthColor", "#ccc");
//   }
// }, 500);

// slider image change
setInterval(() => {
  // for Additional product variant 2nd image change in slider
  document
    .querySelectorAll(
      ".fi-custom-option-selector-additional-product-selected .item"
    )
    .forEach((element) => {
      element.onclick = function () {
        document.querySelector(".fi-product-gallery__thumbnail-custom").click();
      };
    });
  var additionalVariantImageSecond = document.querySelector(
    ".additional-product-data-selected .additional-product-variant-selected"
  ).dataset.imageSecond;
  document.querySelector(".fi-product-gallery__thumbnail-custom img").src =
    additionalVariantImageSecond;
  document.querySelector(".fi-product-gallery__media-custom img").src =
    additionalVariantImageSecond;
}, 200);

// Helper function to update the images
function updateVariantImages(imageSource) {
  setTimeout(() => {
    const thumbnailImg = document.querySelector(
      ".fi-product-gallery__thumbnail-custom img"
    );
    const mediaImg = document.querySelector(
      ".fi-product-gallery__media-custom img"
    );

    if (thumbnailImg && mediaImg) {
      thumbnailImg.src = imageSource;
      mediaImg.src = imageSource;
      document.querySelector(".fi-product-gallery__thumbnail-custom").click(); // Trigger the click after image update
    }
  }, 100); // Small delay to ensure DOM updates
}

// Event listener for main product selection
document
  .querySelectorAll(".fi-custom-option-selector .item")
  .forEach((mainEl) => {
    mainEl.addEventListener("click", () => {
      setTimeout(() => {
        const mainVariantImageSecond = document.querySelector(
          ".main-product-data .main-product-variant-selected"
        )?.dataset.imageSecond;
        if (
          !document
            .querySelector(".additional-product-data")
            .classList.contains("additional-product-data-selected")
        ) {
          if (mainVariantImageSecond) {
            updateVariantImages(mainVariantImageSecond);
          }
        }
      }, 100); // Delay to ensure the variant selection updates
    });
  });

// Event listener for additional product selection
// document
//   .querySelectorAll(
//     ".fi-custom-option-selector-additional-product-selected .item"
//   )
//   .forEach((element) => {
//     element.addEventListener("click", () => {
//       setTimeout(() => {
//         const additionalVariantImageSecond = document.querySelector(
//           ".additional-product-data-selected .additional-product-variant-selected"
//         )?.dataset.imageSecond;

//         if (additionalVariantImageSecond) {
//           updateVariantImages(additionalVariantImageSecond);
//         }
//       }, 100); // Delay to ensure the variant selection updates
//     });
//   });

//

if (window.innerWidth <= 575) {
  document.addEventListener("scroll", function () {
    const priceDiv = document.querySelector("[data-block-id='price']");
    if (window.scrollY >= 120 && window.scrollY < 1000) {
      priceDiv.style.top =
        document.querySelector("product-gallery").offsetHeight + "px";
      priceDiv.classList.add("make-sticky");
    } else {
      priceDiv.classList.remove("make-sticky");
    }
  });

  window.onscroll = function () {
    stickyFunction();
  };

  var stickyElement = document.querySelector("product-gallery");
  var stickyPosition = stickyElement.offsetTop + 1000;

  function stickyFunction() {
    if (window.pageYOffset >= stickyPosition) {
      stickyElement.classList.remove("sticky");
    } else {
      stickyElement.classList.add("sticky");
    }
  }
}

//

setInterval(() => {
  var mainProductVariantDiv = document.querySelector(
    ".main-product-options-data.main-product-variant-selected"
  );
  var additionalProductVariantDiv = document.querySelector(
    ".additional-product-data-selected .additional-product-variant-selected"
  );
  //
  var takePriceAdditional = 0;
  var takeComparePriceAdditional = 0;
  takePriceAdditional =
    parseFloat(additionalProductVariantDiv.dataset.variantPrice) / 100;
  var takePriceMain =
    parseFloat(mainProductVariantDiv.dataset.variantPrice) / 100;
  var makeBundleFinalPrice = (takePriceAdditional + takePriceMain).toFixed(2);
  var makeBundleFinalString = makeBundleFinalPrice.toString();
  var makeBundleFinalPriceWithSymbol = "€ " + makeBundleFinalString + " EUR";
  document.querySelector(".product-info__price sale-price").innerHTML =
    makeBundleFinalPriceWithSymbol.replace(".", ",");
}, 500);

//
document
  .querySelectorAll(
    ".wrapper-dropdown:not(.fi-custom-option-selector-main-product .option-set-1)"
  )
  .forEach((element) => {
    element.classList.add("make-disbaled");
  });

setInterval(() => {
  if (
    !document
      .querySelector(".fi-custom-option-selector-main-product .option-set-2")
      .classList.contains("hidden")
  ) {
    if (
      document.querySelector(
        ".fi-custom-option-selector-main-product .option-set-1 .destination"
      ).dataset.optionValue != "empty"
    ) {
      document
        .querySelector(".fi-custom-option-selector-main-product .option-set-2")
        .classList.remove("make-disbaled");
    }
    if (
      document.querySelector(
        ".fi-custom-option-selector-main-product .option-set-2 .destination"
      ).dataset.optionValue != "empty"
    ) {
      document
        .querySelector(
          ".fi-custom-option-selector-additional-product #dropdownAddProduct"
        )
        .classList.remove("make-disbaled");
    }
    if (
      document.querySelector(
        ".fi-custom-option-selector-additional-product #dropdownAddProduct .destination"
      ).dataset.productId != "empty"
    ) {
      document
        .querySelector(
          ".fi-custom-option-selector-additional-product-selected .option-set-1"
        )
        .classList.remove("make-disbaled");
    }
    if (
      document.querySelector(
        ".fi-custom-option-selector-additional-product-selected .option-set-1 .destination"
      ).dataset.optionValue != "empty"
    ) {
      document
        .querySelector(
          ".fi-custom-option-selector-additional-product-selected .option-set-2"
        )
        .classList.remove("make-disbaled");
    }
  }
  if (
    document
      .querySelector(".fi-custom-option-selector-main-product .option-set-2")
      .classList.contains("hidden")
  ) {
    if (
      document.querySelector(
        ".fi-custom-option-selector-main-product .option-set-1 .destination"
      ).dataset.optionValue != "empty"
    ) {
      document
        .querySelector(
          ".fi-custom-option-selector-additional-product #dropdownAddProduct"
        )
        .classList.remove("make-disbaled");
    }
    if (
      document.querySelector(
        ".fi-custom-option-selector-additional-product #dropdownAddProduct .destination"
      ).dataset.productId != "empty"
    ) {
      document
        .querySelector(
          ".fi-custom-option-selector-additional-product-selected .option-set-1"
        )
        .classList.remove("make-disbaled");
    }
    if (
      document.querySelector(
        ".fi-custom-option-selector-additional-product-selected .option-set-1 .destination"
      ).dataset.optionValue != "empty"
    ) {
      document
        .querySelector(
          ".fi-custom-option-selector-additional-product-selected .option-set-2"
        )
        .classList.remove("make-disbaled");
    }
  }
}, 800);
